function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("linearGradient", {
  id: "pxs5hthcxc",
  x1: "35.152%",
  x2: "121.5%",
  y1: "66.505%",
  y2: "-100.5%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#6A2D87"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#A93D69"
}));
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#pxs5hthcxc)",
  d: "M12 3L1 9l4 2.18v6L12 21l7-3.82v-6l2-1.09V17h2V9L12 3zm6.82 6L12 12.72 5.18 9 12 5.28 18.82 9zM17 15.99l-5 2.73-5-2.73v-3.72L12 15l5-2.73v3.72z"
});
const SvgNewProductMycpe = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgNewProductMycpe, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/new-product-mycpe.d5d1b308.svg";
export { ForwardRef as ReactComponent };